export const ADD_MESSAGES = 'ADD_MESSAGES';
export const SET_MESSAGES = 'SET_MESSAGES';
//export const SET_USERS_COUNT = 'SET_USERS_COUNT';
//export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CONNECTION_ESTABLISHED = 'SET_CONNECTION_ESTABLISHED';
export const SET_CONNECTION_ID = 'SET_CONNECTION_ID';
export const UPDATE_QUESTIONS = 'UPDATE_QUESTIONS';